import "../product-minature"
import "jquery-lazy/jquery.lazy.min"


$('.category__ordering').select2({
    minimumResultsForSearch: -1,
    selectionCssClass: ":all:",
    dropdownAutoWidth: 'true',
    width: 'auto'
});
